import { render, staticRenderFns } from "./EsamiSpecialisticiIntegrativiEditComponent.vue?vue&type=template&id=c1c8152e"
import script from "./EsamiSpecialisticiIntegrativiEditComponent.vue?vue&type=script&lang=js"
export * from "./EsamiSpecialisticiIntegrativiEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports